const CueOptions = [
    {
        'part': 'Intro',
        'midi': 'F2'
    },
    {
        'part': 'Verse',
        'midi': 'F#2'
    },
    {
        'part': 'Verse 1',
        'midi': 'G2'
    },
    {
        'part': 'Verse 2',
        'midi': 'G#2'
    },
    {
        'part': 'Verse 3',
        'midi': 'A2'
    },
    {
        'part': 'Verse 4',
        'midi': 'A#2'
    },
    {
        'part': 'Pre Chorus',
        'midi': 'B2'
    },
    {
        'part': 'Chorus',
        'midi': 'C3'
    },
    {
        'part': 'Chorus 1',
        'midi': 'C#3'
    },
    {
        'part': 'Chorus 2',
        'midi': 'D3'
    },
    {
        'part': 'Chorus 3',
        'midi': 'D#3'
    },
    {
        'part': 'Chorus 4',
        'midi': 'E3'
    },
    {
        'part': 'Post Chorus',
        'midi': 'F3'
    },
    {
        'part': 'Bridge',
        'midi': 'F#3'
    },
    {
        'part': 'Bridge 1',
        'midi': 'G3'
    },
    {
        'part': 'Bridge 2',
        'midi': 'G#3'
    },
    {
        'part': 'Bridge 3',
        'midi': 'A3'
    },
    {
        'part': 'Bridge 4',
        'midi': 'A#3'
    },
    {
        'part': 'Tag',
        'midi': 'B3'
    },
    {
        'part': 'Instrumental',
        'midi': 'C4'
    },
    {
        'part': 'Turnaround',
        'midi': 'C#4'
    },
    {
        'part': 'Solo',
        'midi': 'D4'
    },
    {
        'part': 'Outro',
        'midi': 'D#4'
    },
    {
        'part': 'Breakdown',
        'midi': 'F4'
    },
    {
        'part': 'Acapella',
        'midi': 'F#4'
    },
    {
        'part': 'All In',
        'midi': 'G4'
    },
    {
        'part': 'Big Ending',
        'midi': 'G#4'
    },
    {
        'part': 'Break',
        'midi': 'A4'
    },
    {
        'part': 'Build',
        'midi': 'A#4'
    },
    {
        'part': 'Bass',
        'midi': 'B4'
    },
    {
        'part': 'Drums In',
        'midi': 'C5'
    },
    {
        'part': 'Key change up',
        'midi': 'C#5'
    },
    {
        'part': 'Key change down',
        'midi': 'D5'
    },
    {
        'part': 'Last time',
        'midi': 'D#5'
    },
    {
        'part': 'Slowly build',
        'midi': 'E5'
    },
    {
        'part': 'Softly',
        'midi': 'F6'
    },
]

export default CueOptions;